import React from "react";
import { X, Check, ShieldAlert } from "lucide-react";

export const PageHead = ({ eyebrow, title, sub, tone = "violet" }) => {
  const glow = {
    violet: "rgba(155,92,255,0.25)",
    cyan: "rgba(36,224,255,0.25)",
    blue: "rgba(59,123,255,0.22)",
  }[tone];
  return (
    <div className="relative border-b border-[color:var(--line)] overflow-hidden noise">
      <div className="absolute inset-0 opacity-30" style={{ background: `radial-gradient(60% 100% at 50% 0%, ${glow}, transparent 60%)` }} />
      <div className="relative mx-auto max-w-[1000px] px-5 py-16">
        {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
        <h1 className="h-display text-4xl sm:text-5xl lg:text-6xl text-chrome leading-[1.02]">{title}</h1>
        {sub && <p className="text-[color:var(--chrome-2)] mt-5 max-w-2xl leading-relaxed">{sub}</p>}
      </div>
    </div>
  );
};

export const Wrap = ({ children, className = "" }) => (
  <div className={`mx-auto max-w-[900px] px-5 ${className}`}>{children}</div>
);

export const H2 = ({ children, className = "" }) => (
  <h2 className={`h-display text-2xl sm:text-3xl text-chrome leading-tight ${className}`}>{children}</h2>
);

export const Lead = ({ children }) => (
  <p className="text-lg text-[color:var(--chrome-1)] leading-relaxed">{children}</p>
);

export const P = ({ children, className = "" }) => (
  <p className={`text-[color:var(--chrome-2)] leading-relaxed ${className}`}>{children}</p>
);

export const Prose = ({ children, className = "" }) => (
  <div className={`space-y-5 ${className}`}>{children}</div>
);

export const Impact = ({ children, tone = "chrome" }) => (
  <p className={`h-display text-xl sm:text-2xl leading-tight ${tone === "holo" ? "text-holo" : "text-chrome"}`}>{children}</p>
);

export const Callout = ({ children, className = "", holo = false }) => (
  <div className={`rounded-2xl p-6 sm:p-8 ${holo ? "holo-border holo-glow" : "border border-[color:var(--line)] glass"} ${className}`}>{children}</div>
);

export const DontList = ({ items }) => (
  <ul className="space-y-2.5">
    {items.map((t, i) => (
      <li key={i} className="flex items-start gap-3 text-[color:var(--chrome-1)]">
        <X size={18} className="text-[color:var(--magenta)] shrink-0 mt-0.5" />
        <span>{t}</span>
      </li>
    ))}
  </ul>
);

export const CheckList = ({ items }) => (
  <ul className="space-y-2.5">
    {items.map((t, i) => (
      <li key={i} className="flex items-start gap-3 text-[color:var(--chrome-1)]">
        <Check size={18} className="text-[color:var(--cyan)] shrink-0 mt-0.5" />
        <span>{t}</span>
      </li>
    ))}
  </ul>
);

export const Disclaimer = ({ children }) => (
  <div className="flex items-start gap-3 rounded-xl border border-[color:var(--line)] p-4 text-sm text-[color:var(--chrome-3)]">
    <ShieldAlert size={16} className="text-[color:var(--chrome-2)] shrink-0 mt-0.5" />
    <div className="space-y-1.5">{children}</div>
  </div>
);
